<template>
	<main>
		<crumbs :crumbs="crumbs"></crumbs>
		<div class="wrap">
			<div class="title-box">
				<div class="title">解决方案精选</div>
				<div class="min-title">大会精彩内容抢先观看，为您解读不同解决方案的打开方式。</div>
			</div>
			<div class="category">
				<div class="item" v-for="(item,index) in category_list" @click="chooseCategory(item,index)" :style="{backgroundImage:'url('+util.autoImage((category.id == item.id ? item.bg : item.bg2))+')'}" :class="[category.id == item.id ? 'active' : '']" >
					<div class="cen">
						<div class="middle">
							<div class="icon"><img :src="util.autoImage(item.icon)" alt=""></div>
							<div class="icon icon-a"><img :src="util.autoImage(item.icon2)" alt=""></div>
							<div class="tit">{{item.title}}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="one" v-if="one.id">
				<div class="video-box">
					<video controls id="s1_video" :poster="util.autoImage(one.image)" loop @click.prevent="stopVideo" :src="util.autoImage(one.url)"></video>
					<div class="mark" v-if="s1_play_show">
						<div class="play" @click="playVideo"></div>
					</div>
				</div>
				<div class="info">
					<div class="tit">{{one.category_title}}</div>
					<div class="element-more min-tit
">{{one.title}}</div>
				</div>
			</div>
			<div class="list">
				<div class="item" v-for="(item,index) in video_list" @click="setOne(item)">
					<div class="image-box">
						<div class="image" :style="{backgroundImage:'url('+(item.image ? util.autoImage(item.image): util.autoImage(item.video)+'?x-oss-process=video/snapshot,t_0,f_jpg,m_fast')+')'}"><div class="play"></div></div>
					</div>
					<div class="info">
						<div class="tit">{{item.category_title}}</div>
						<div class="element-more min-tit
">{{item.title}}</div>
					</div>
				</div>
			</div>
			<div class="empty" v-if="video_list.length <= 0">暂无数据</div>
			<div class="banner" @click="toBanner" v-if="banner.id" :style="{backgroundImage:'url('+util.autoImage(banner.image)+')'}"></div>
		</div>
		<video-float v-if="video_info.title" :video_info="video_info" @hideVideo="hideVideo"></video-float>
	</main>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import 'swiper/dist/css/swiper.css'
import Crumbs from "../../components/pc/Crumbs";
import Loading from "../../components/pc/Loading";
import VideoFloat from "../../components/pc/VideoFloat";
export default {
	name: 'my-video',
	data() {
		return {
			query:"",
			category_list:[],
			category:{},
			video_list:[],
			one:{},
			data_loading:true,

			video_info:{},
			s1_play_show:true,

			banner:{},
		}
	},
	components:{
		Crumbs,Loading,swiper,swiperSlide,VideoFloat
	},
	computed:{
		crumbs() {
			return {title:"解锁超多精彩内容",min_title:"SNEAK PEEK"}
		},
	},
	methods: {
		setOne(item){
			this.one = item;
			this.$nextTick(()=>{
				document.documentElement.scrollTop = document.querySelector('.one').offsetTop-80
				this.playVideo();
			})
		},
		toBanner(){
			if(this.banner.link){
				window.open(this.banner.link);
			}else{
				this.util.showWait(true)
			}
		},
		playVideo(){
			gio('track', 'DTF2021_videoclick',{
				DTF2021_videotitle:this.one.title,
			});

			var video = document.getElementById('s1_video');
			video.addEventListener('play',()=>{
				this.s1_play_show = false;
			})
			video.addEventListener('pause',()=>{
				this.s1_play_show = true;
			})
			video.play();
		},
		stopVideo(){
			var video = document.getElementById('s1_video');
			video.pause();
		},
		showVideo(item){
			item.video = item.url;
			this.video_info = item;
		},
		hideVideo(){
			this.video_info = {}
		},
		swiperInit(){
			this.swiper = new Swiper('#swiper-category',{
				slidesPerView:this.category_list.length > 5 ? 4.5 : 5,
				spaceBetween: 15,
				watchOverflow:true,
				slideToClickedSlide:true,
				observer:true,
				observeSlideChildren:true,
			})
		},
		chooseCategory(item,index){
			this.category = item;
			this.getVideoList();
		},
		getVideoList(){
			this.http.request({
				api:"video/getVideoList",
				data:{
					video_category_id:this.category.id
				},
				success:(res)=>{
					this.video_list = res.list;
					this.one = res.list && res.list.length > 0 ? res.list[0] : {};
					this.data_loading = false;
					this.$nextTick(()=>{
						this.util.showBottom(true);
					})
				}
			})
		},
		getCategoryList(){
			this.http.request({
				api:"video/getCategoryList",
				success:(res)=>{
					this.category_list = res.category;
					this.category = res.category[0];
					this.getVideoList();
					this.$nextTick(()=>{
						this.swiperInit();
					})
				}
			})
		},
		getAdv(){
			this.http.request({
				api:"adv/getAdv",
				data:{
					position:1,
				},
				success:(res)=>{
					this.banner = res.adv[0];
				}
			})
		}
	},
	mounted() {
		this.query = this.$route.query;
		this.getCategoryList();
		this.getAdv();
	}
}
</script>

<style lang="scss" type="text/scss" scoped>
.wrap{margin: 40px auto 0;background: url("~@/assets/image/2021/17.png") no-repeat bottom center;background-size:100% auto;
	.title-box{width: 1200px;margin: 0 auto;background: url("~@/assets/image/2021/10.png") no-repeat left center;background-size: 100px;text-align: left;
		.title{font-size: 54px;line-height: 70px;color:#376f84;margin-left: 30px;}
		.min-title{font-size:18px;color:#444;margin-top: 10px;margin-left: 30px;}
	}
	.category{width: 1200px;margin: 40px auto 0;display: flex;
		.item{flex: 1; height:140px;border-radius: 5px; box-shadow: 0 0 10px 2px rgba(0,0,0,.1); position: relative;cursor: pointer;text-align: center;transition: all .3s ease;margin-right: 20px;
			.cen{display: inline-block;
				.middle{text-align: center;transition: all .3s ease;height:140px;
					.icon{width: 50px;height:70px;display: block;margin: 0 auto;
						img{width: 100%;height:100%;object-fit: contain;}
					}
					.icon-a{display: none;}
					.tit{color:#333;font-size: 16px;line-height: 36px;}
				}
			}
		}
		.item:nth-last-child(1){margin-right: 0;}
		.item.active{transition: all .3s ease;background: url("~@/assets/image/b44.jpg") no-repeat center center;background-size: cover;
			.cen{
				.middle{
					.icon{display: none;}
					.icon-a{display: block;}
					.tit{color:#fff;}
				}
			}
		}
		.item:nth-last-child(1){margin-right: 0;}
	}
	.one{width: 1200px;padding-top: 40px; margin: 0 auto 0;background: url("~@/assets/image/2021/10.png") no-repeat left bottom;background-size: 100px;
		.video-box{width: 997px;height:560px;margin: 0 auto; background-color: #999;background-repeat: no-repeat;background-position: center center;background-size: cover;position: relative;
			video{width: 100%;height:100%;object-fit: cover;}
			.mark{position: absolute;width: 100%;height:100%;top:0;left:0;background: rgba(0,0,0,.5);
				.play{position: absolute;top:50%;left:50%;width: 70px;height:70px;background: url("~@/assets/image/2021/7.png") no-repeat center center;background-size: contain;margin-top: -35px;margin-left: -35px;cursor: pointer;}
			}
		}
		.info{width: 997px;margin: 15px auto 0;padding-bottom: 20px;
			.tit{font-size: 16px;line-height: 21px;color:#41B6E6;
				i{font-weight: bold;margin-left: 5px;}
			}
			.min-tit{font-size: 24px;line-height:1;color:#444444;font-weight: bold;margin-top: 10px;}
		}
	}
	.list{width: 1200px;margin: 40px auto 0;overflow:hidden;padding: 10px 0;
		.item{float: left;width: 285px;margin-right: 20px;text-align: left;transition: all .3s ease;background: #fafafa;box-shadow: 0 0 10px 2px rgb(0,0,0,.03);margin-bottom: 20px;
			.image-box{padding: 15px;
				.image{height:160px;background:url("~@/assets/image/11.png") no-repeat center center;background-size: cover;position: relative;
					.play{width: 45px;height:45px;position: absolute;top:50%;left:50%;background: url("~@/assets/image/2021/7.png") no-repeat left center;background-size: contain;margin-left: -22px;margin-top: -22px; cursor: pointer;z-index: 2;}
				}
				.image::after{content: "";display: block;position: absolute;top:0;left:0;width: 100%;height:100%; background: rgba(0,0,0,.5);z-index: 1;}
			}
			.info{border: 1px solid #fafafa;padding:0 15px 15px;box-sizing: border-box;
				.tit{font-size: 14px;line-height: 19px;color:#41B6E6;
					i{font-weight: bold;margin-left: 2px;}
				}
				.min-tit{font-size: 16px;color:#1A1A1A;line-height: 24px;min-height:48px; -webkit-line-clamp: 2;}
			}
		}
		.item:hover{box-shadow: 0 0 10px 2px rgb(0,118,206,.3);}
		.item:nth-child(4n+4){margin-right: 0;}
	}
	.tips { font-size:14px; padding-bottom: 50px;text-align: left;color:#999;width: 1200px;margin: 0 auto;
		i{color:red;}
	}
	.banner{width: 1200px;height:200px; margin:0 auto 0;padding-bottom: 30px;cursor:pointer;background: url("~@/assets/image/2021/25.png") no-repeat center center;background-size: contain;}
}

</style>

